class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      console.log('imported')
    }
  
    connectedCallback() {

      this.anchor = this.querySelector("#endless-scroll-anchor");
  
      if (this.anchor) {
     
        this.observer = new IntersectionObserver(this.onIntersect.bind(this));
        this.observer.observe(this.anchor);
      }
    }
  
    disconnectedCallback() {
      
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  
    onIntersect(entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        const nextPageUrl = this.anchor.getAttribute("data-next-page");
        if (nextPageUrl) {
          this.loadNextPage(nextPageUrl);
        }
      }
    }
  
    loadNextPage(url) {
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
  
          const newProducts = doc.querySelector("[data-products-grid] .grid").innerHTML;
          this.querySelector("[data-products-grid] .grid").insertAdjacentHTML("beforeend", newProducts);
  
    
          const nextAnchor = doc.getElementById("endless-scroll-anchor");
          if (nextAnchor) {
            const nextPage = nextAnchor.getAttribute("data-next-page");
            this.anchor.setAttribute("data-next-page", nextPage);
          } else {
  
            this.anchor.remove();
            this.observer.disconnect();
          }
        })
        .catch((error) => console.error("Error loading the next page:", error));
    }
  }
  

  customElements.define("infinite-scroll", InfiniteScroll);